import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TrashIcon from "../SVG/TrashIcon";
import "./UIUploadedFile.scss";

const UIUploadedFile = ({ fileName, successLabel, onRemove }) => (
  <Box className="ui-uploaded-file">
    <CheckCircleOutlineIcon className="ui-uploaded-file__check" />
    <Box className="ui-uploaded-file__content">
      <Typography className="ui-uploaded-file__name">{fileName}</Typography>
      <Typography className="ui-uploaded-file__success">
        {successLabel}
      </Typography>
    </Box>
    {onRemove && (
      <IconButton
        type="button"
        className="ui-uploaded-file__remove"
        aria-label="Remove file"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove();
        }}
      >
        <TrashIcon width={24} height={24} color="rgba(102, 102, 102, 1)" />
      </IconButton>
    )}
  </Box>
);

UIUploadedFile.propTypes = {
  fileName: PropTypes.string,
  successLabel: PropTypes.node,
  onRemove: PropTypes.func,
};

UIUploadedFile.defaultProps = {
  fileName: "",
  successLabel: "Uploaded Successfully",
  onRemove: undefined,
};

export default UIUploadedFile;
